module.exports = __webpack_public_path__ + "img/public/SiteIcons/viewAllArrow.svg?bc987c4f";